import React from "react";
import { useTranslation } from "react-i18next";
import { Heart, Instagram, Mail } from "lucide-react";

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#2C3E50] text-white py-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* About */}
          <div>
            <h3 className="text-xl font-serif font-bold mb-4">{t('header.name')}</h3>
            <p className="text-gray-300 leading-relaxed">
              {t('footer.about')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-serif font-bold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => document.getElementById("home")?.scrollIntoView({ behavior: "smooth" })}
                  className="text-gray-300 hover:text-[#7C9885] transition-colors duration-200"
                >
                  {t('header.home')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById("services")?.scrollIntoView({ behavior: "smooth" })}
                  className="text-gray-300 hover:text-[#7C9885] transition-colors duration-200"
                >
                  {t('header.services')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById("philosophy")?.scrollIntoView({ behavior: "smooth" })}
                  className="text-gray-300 hover:text-[#7C9885] transition-colors duration-200"
                >
                  {t('header.philosophy')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
                  className="text-gray-300 hover:text-[#7C9885] transition-colors duration-200"
                >
                  {t('header.contact')}
                </button>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h3 className="text-xl font-serif font-bold mb-4">{t('footer.connect')}</h3>
            <div className="space-y-3">
              <a
                href="https://www.instagram.com/chabouredouan"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-gray-300 hover:text-[#7C9885] transition-colors duration-200"
              >
                <Instagram className="w-5 h-5" />
                <span>@chabouredouan</span>
              </a>
              <a
                href="mailto:redchabou@gmail.com"
                className="flex items-center gap-2 text-gray-300 hover:text-[#7C9885] transition-colors duration-200"
              >
                <Mail className="w-5 h-5" />
                <span>redchabou@gmail.com</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              {t('footer.copyright', { year: currentYear })}
            </p>
            <p className="text-gray-400 text-sm flex items-center gap-1">
              {t('footer.madeWith')} <Heart className="w-4 h-4 text-[#C17A6F]" /> for healing and growth
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;